export default {"src":"/_next/static/media/gift_box.85661d35.svg","height":97,"width":109};